import type { SxProps } from "@mui/material";
import { Button, Input, MenuItem, Select } from "@mui/material";
import type { FC, PropsWithChildren, ReactNode } from "react";
import { useState } from "react";

interface MenuItem {
  readonly name: string;
  readonly disabled?: boolean;
  readonly onClick: () => void | Promise<void>;
}

interface Props {
  readonly loading?: boolean;
  readonly startIcon?: ReactNode;
  readonly variant?: "outlined" | "contained" | "text";
  readonly color?: "primary" | "secondary" | "error" | "inherit";
  readonly sx?: SxProps;
  readonly menuItems: MenuItem[];
}

const ButtonWithContextMenu: FC<PropsWithChildren<Props>> = ({
  children,
  loading,
  variant = "outlined",
  color = "secondary",
  menuItems,
  sx,
  startIcon,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <Button
      variant={variant}
      color={color}
      startIcon={startIcon}
      loadingPosition="start"
      sx={sx}
      loading={loading}
      onClick={(e) => {
        e.stopPropagation();
        if (open) {
          return;
        }
        setOpen(true);
      }}
    >
      {children}
      <Select
        open={open}
        input={<Input style={{ width: 0, height: 0, visibility: "hidden" }} />}
        onClose={() => setOpen(false)}
        value={""}
      >
        {menuItems.map(({ name, disabled, onClick }) => (
          <MenuItem
            key={name}
            disabled={disabled}
            onClick={async (e) => {
              e.stopPropagation();
              setOpen(false);
              await onClick();
            }}
          >
            {name}
          </MenuItem>
        ))}
      </Select>
    </Button>
  );
};

export default ButtonWithContextMenu;
